import { render, staticRenderFns } from "./oferta.vue?vue&type=template&id=2e3902d1"
import script from "./oferta.vue?vue&type=script&lang=js"
export * from "./oferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports